'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { parseAsStringLiteral, useQueryState } from 'nuqs';
import { useSignUpQ1Variant } from '../../_hooks/use-sign-up-q1-variant';
import { useSignUpFlowStore } from './use-sign-up-flow-store';
const STEP_OPTIONS = ['start', 'email-verification', 'choose'] as const;
const stepParser = parseAsStringLiteral(STEP_OPTIONS).withDefault('start');
export function useSignUpStepUrlSync() {
  const $ = _c(10);
  const {
    variant
  } = useSignUpQ1Variant();
  const [urlStep, setUrlStep] = useQueryState("step", stepParser);
  const step = useSignUpFlowStore(_temp);
  const onChange = useSignUpFlowStore(_temp2);
  const isControl = variant !== "experiment";
  let t0;
  let t1;
  if ($[0] !== onChange || $[1] !== urlStep) {
    t0 = () => {
      onChange({
        step: urlStep
      });
    };
    t1 = [urlStep, onChange];
    $[0] = onChange;
    $[1] = urlStep;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[4] !== isControl || $[5] !== setUrlStep || $[6] !== step || $[7] !== urlStep) {
    t2 = () => {
      if (!isControl) {
        return;
      }
      if (step !== urlStep && STEP_OPTIONS.includes(step)) {
        setUrlStep(step).catch(_temp3);
      }
    };
    t3 = [isControl, step, urlStep, setUrlStep];
    $[4] = isControl;
    $[5] = setUrlStep;
    $[6] = step;
    $[7] = urlStep;
    $[8] = t2;
    $[9] = t3;
  } else {
    t2 = $[8];
    t3 = $[9];
  }
  useEffect(t2, t3);
}
function _temp3() {}
function _temp2(s_0) {
  return s_0.onChange;
}
function _temp(s) {
  return s.step;
}